<app-main></app-main>
<app-about-me></app-about-me>
<app-skills></app-skills>
<app-repositories></app-repositories>
<app-experience></app-experience>
<app-education></app-education>
<app-contact></app-contact>
